import { Component, OnInit, Input } from '@angular/core';

/**
 * A component for display the win or loss condition of a event or match of the athlete
 *
 * @export
 * @class WinLossEventComponent
 * @implements {OnInit}
 */
@Component({
  selector: 'app-win-loss-event',
  templateUrl: './win-loss-event.component.html',
  styleUrls: ['./win-loss-event.component.scss']
})
export class WinLossEventComponent implements OnInit {

  /**
   * Input property of self points
   *
   * @type {number}
   * @memberof WinLossEventComponent
   */
  @Input()
  selfPoints:number;

  /**
   * Input property of anothers points
   *
   * @type {number}
   * @memberof WinLossEventComponent
   */
  @Input()
  otherPoints:number;

  /**
   * Input property of who wins. If true wins the self athlete and green should be render.
   *
   * @type {boolean}
   * @memberof WinLossEventComponent
   */
  @Input()
  winLoss:boolean;
  constructor() { }

  /**
   * Input property to decide where to show the score
   *
   * @memberof WinLossEventComponent
   */
  @Input()
  onRight = true;

  /**
   * @inheritdoc
   * @memberof WinLossEventComponent
   */
  ngOnInit() {
    if(this.selfPoints==undefined){
      throw new Error("property input selfPoints it's not defined please bind property <app-win-loss-event [selfPoints]='your-data'")
    }
    if(this.otherPoints==undefined){
      throw new Error("property input otherPoints it's not defined please bind property <app-win-loss-event [otherPoints]='your-data'")
    }
    if(this.winLoss==undefined){
      throw new Error("property input winLoss it's not defined please bind property <app-win-loss-event [winLoss]='your-data'")
    }
  }

}
